import {
  ApolloClientOptions,
  InMemoryCache,
  NormalizedCacheObject,
} from '@apollo/client';

import { AccessTokenProvider } from './types';

export type ApolloClientFactoryOptions = {
  uri: string;
  /**
   * Role to use for GraphQL requests. Can be a static string or a
   * (possibly async) function that resolves per request — useful for
   * picking between `reviewer` and `ml-engineer` based on session flags.
   * When undefined, the session's default role is used.
   */
  desiredRole?:
    | string
    | (() => string | undefined | Promise<string | undefined>);
  enableSubscriptions?: boolean;
  cacheInstance: InMemoryCache;
  accessTokenProvider: AccessTokenProvider;
} & Pick<ApolloClientOptions<NormalizedCacheObject>, 'defaultOptions'>;

export const defaultApolloClientOptions: ApolloClientOptions<NormalizedCacheObject>['defaultOptions'] =
  {
    watchQuery: {
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-first',
    },
  };
